import VueGtag, { trackRouter } from 'vue-gtag-next'

export default defineNuxtPlugin((nuxtApp) => {
  const { isAccepted } = useCookieConsent()
  if (!isAccepted.value) return

  const config = useRuntimeConfig()
  nuxtApp.vueApp.use(VueGtag, {
    property: {
      id: config.public.googleAnalyticsId,
    },
  })
  trackRouter(useRouter())
})
